import { accessCardService } from "@services";
import { maskActions } from "./mask.actions";
import { accessCardConstants } from "@constants";
import { message } from "antd";
import { msgTypes, showModal } from "@utils";

export const accessCardActions = {
  /**
   * 取得建案門禁卡列表
   * @param {string} constructionUuid - 建案 uuid
   * @param {object} condition - 查詢條件
   * @returns
   */
  getAll: (constructionUuid, condition) => {
    return dispatch => {
      dispatch({
        type: accessCardConstants.GET_ALL_REQUEST
      });

      accessCardService.getAll(constructionUuid, condition).then(
        ({ items, total }) => {
          dispatch({
            type: accessCardConstants.GET_ALL_SUCCESS,
            constructionUuid,
            items,
            total,
            condition
          });
        },
        error => {
          dispatch({
            type: accessCardConstants.GET_ALL_FAILURE,
            error
          });
        }
      );
    };
  },
  /**
   * 重設建案門禁卡列表
   * @returns
   */
  resetAll: () => ({
    type: accessCardConstants.RESET_ALL_SUCCESS
  }),
  /**
   * 新增門禁卡
   * @param {string} constructionUuid - 建案 uuid
   * @param {object} info - 門禁卡資訊
   * @param {function} cbSuccess - 成功後的 callback
   * @returns
   */
  create: (constructionUuid, info, cbSuccess) => {
    return (dispatch, getState) => {
      dispatch({
        type: accessCardConstants.EDIT_REQUEST
      });
      accessCardService.create(constructionUuid, info).then(
        response => {
          dispatch({
            type: accessCardConstants.EDIT_SUCCESS
          });
          cbSuccess && cbSuccess();
          message.success(response);
          accessCardActions.__getAll(dispatch, getState);
        },
        error => {
          dispatch({
            type: accessCardConstants.EDIT_FAILURE,
            error
          });
        }
      );
    };
  },
  /**
   * 重設門禁卡編輯
   * @returns
   */
  resetEdit: () => ({
    type: accessCardConstants.RESET_EDIT_SUCCESS
  }),
  /**
   * 新增門禁卡 For 加入住戶
   * @param {string} constructionUuid - 建案 uuid
   * @param {object} info - 門禁卡資訊
   * @param {function} cbSuccess - 成功後的 callback
   * @returns
   */
  createForJoinHousehold: (constructionUuid, cardNumber, cbSuccess) => {
    return dispatch => {
      dispatch(maskActions.toggleMask(true));
      accessCardService
        .create(constructionUuid, {
          card_number: cardNumber
        })
        .then(
          response => {
            cbSuccess && cbSuccess();
            message.success(response);
          },
          error => {
            showModal(msgTypes.ERROR, "錯誤", error);
          }
        )
        .finally(() => {
          dispatch(maskActions.toggleMask(false));
        });
    };
  },
  /**
   * 刪除門禁卡
   * @param {number} id - 門禁卡 id
   * @returns
   */
  delete: id => {
    return (dispatch, getState) => {
      dispatch(maskActions.toggleMask(true));
      accessCardService
        .delete(id)
        .then(
          response => {
            message.success(response);
            accessCardActions.__getAll(dispatch, getState);
          },
          error => {
            showModal(msgTypes.ERROR, "錯誤", error);
          }
        )
        .finally(() => {
          dispatch(maskActions.toggleMask(false));
        });
    };
  },
  /**
   * 取得門禁卡 by 門禁卡號碼
   * @key GetConstructionAccessCardNumberByProperty
   * @param {string} constructionUuid - 建案 uuid
   * @param {string} cardNumber - 門禁卡號碼
   * @param {function} cbSuccess - 成功後的 callback
   * @param {function} cbError - 失敗後的 callback
   * @returns
   */
  getAccessCardByNumber: (constructionUuid, cardNumber, cbSuccess, cbError) => {
    return dispatch => {
      dispatch(maskActions.toggleMask(true));

      accessCardService
        .getByNumber(constructionUuid, cardNumber)
        .then(
          card => {
            cbSuccess && cbSuccess(card);
          },
          error => {
            if (cbError) {
              cbError(error);
            } else {
              message.error(error.message);
            }
          }
        )
        .finally(() => {
          dispatch(maskActions.toggleMask(false));
        });
    };
  },
  /**
   * 修改門禁卡資料
   * @param {number} id - 門禁卡 id
   * @param {object} info - 門禁卡資訊
   * @param {function} cbSuccess - 成功後的 callback
   * @returns
   */
  update: (id, info, cbSuccess) => {
    return (dispatch, getState) => {
      dispatch({
        type: accessCardConstants.EDIT_REQUEST
      });
      accessCardService.update(id, info).then(
        response => {
          dispatch({
            type: accessCardConstants.EDIT_REQUEST
          });
          cbSuccess && cbSuccess();
          message.success(response);
          accessCardActions.__getAll(dispatch, getState);
        },
        error => {
          dispatch({
            type: accessCardConstants.EDIT_FAILURE,
            error
          });
        }
      );
    };
  },
  /**
   * 取得門禁卡
   * @param {number} id - 門禁卡 id
   * @param {function} cbSuccess - 成功後的 callback
   * @param {function} cbError - 失敗後的 callback
   * @returns
   */
  getEdited: (id, cbSuccess, cbError) => {
    return dispatch => {
      dispatch({
        type: accessCardConstants.GET_EDIT_REQUEST
      });
      accessCardService
        .get(id)
        .then(
          accessCard => {
            cbSuccess && cbSuccess(accessCard);
          },
          error => {
            cbError && cbError(error);
            showModal(msgTypes.ERROR, "錯誤", error);
          }
        )
        .finally(() => {
          dispatch({
            type: accessCardConstants.GET_EDIT_DONE
          });
        });
    };
  },
  __getAll: (dispatch, getState) => {
    const { accessCards } = getState();
    dispatch(
      accessCardActions.getAll(accessCards?.query?.constructionUuid, accessCards?.query?.condition)
    );
  }
};
